// Colocated strings for ItemsGrid (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// Lifted verbatim from the app's `src/locales.js` (same names, top level) when the component
// moved into @rdrive/ui (2026-09-30). All twelve exist in all 10 bundles there. Most of
// them are ALSO registered at the app's root — `TeamsPageAssignment`, `DocumentsPage` and
// `useItemsGridReport` render the same keys: seven as rdrive vocabulary words
// (`packages/rdrive-vocabulary`, never imported here) since 2026-10-02, `today`/`dayAgo`/
// `daysAgo` in the app's `src/locales/` — so these copies shadow the root's, the way the
// base chart's `total` does.
//
// `search`, `noData` and `itemsPerPage` left at IA_ABSORPTION_PLAN 13.3b (2026-10-09): the
// search field and the phone table are DuckDbDataTable's (@rdrive/plugin-data-table), which
// owns those three — the same values in all 10 locales as the copies that were here.
//
// Not a key, and still an English literal in the component: the 'Unknown User' fallback in
// the "+N" avatar tooltip (translation debt). The phone table's one header title 'Items' is
// the table's now (hidden by its style.css, as it was here).
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
